module.exports = __webpack_public_path__ + "assets/d8019aa16ee4ae69107a526d4acc7907.jpg";